export default __webpack_public_path__ + "static/media/Hero.35b18ed1.png";